import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
import 'github-markdown-css';
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h1: "h1",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "ASCII 在线查询"
    }), "\n", _jsxs(_components.p, {
      children: ["ASCII，", _jsx(_components.code, {
        children: "American Standard Code for Information Interchange"
      }), "，美国信息交换标准代码，是基于拉丁字母(罗马字母)的一套电脑编码系统。"]
    }), "\n", _jsxs(_components.p, {
      children: ["ASCII 等同于国际标准 ISO/IEC 646，共 128 个字符，其中 ", _jsx(_components.code, {
        children: "0-31"
      }), " 与 ", _jsx(_components.code, {
        children: "127"
      }), " 共 33 个字符为控制字符（Control Character），其余为可打印字符（printable characters）。"]
    }), "\n", _jsxs(_components.p, {
      children: ["见 ", _jsx(_components.a, {
        href: "https://zh.wikipedia.org/zh-cn/ASCII",
        children: "ASCII"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["控制字符见 ", _jsx(_components.a, {
        href: "https://zh.wikipedia.org/wiki/C0%E4%B8%8EC1%E6%8E%A7%E5%88%B6%E5%AD%97%E7%AC%A6#C0_(ASCII%E5%8F%8A%E5%85%B6%E6%B4%BE%E7%94%9F)",
        children: "C0"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
